<template>
  <label
    :class="[
      styles.themes[theme],
      styles.sizes[size],
      styles.round[rounded],
      styles.component,
      borderClass,
      textClass,
      backgroundClass,
    ]"
  >
    <slot />
  </label>
</template>

<script setup>
defineOptions({
  name: 'V2AtomsLabel'
})

const props = defineProps({
  theme: {
    type: String,
    default: 'default',
    validator: value => ['default', 'outline', 'inverted'].includes(value)
  },

  size: {
    type: String,
    default: 'base',
    validator: value => ['base', 'small', 'large'].includes(value)
  },

  rounded: {
    type: String,
    default: 'base',
    validator: value => ['base', 'full'].includes(value)
  },

  borderClass: {
    type: String,
    default: ''
  },

  fillWidth: {
    type: Boolean,
    default: false
  },

  textClass: {
    type: String,
    default: ''
  },

  backgroundClass: {
    type: String,
    default: ''
  }
})

const styles = computed(() => {
  return {
    themes: {
      default:
        'bg-semantic-inverse-primary text-semantic-surface-on-surface',
      outline:
        'bg-transparent border-semantic-outline-variant-dark border text-semantic-surface-on-surface',
      inverted:
        'bg-semantic-inverse-surface-light text-semantic-inverse-on-surface'
    },
    sizes: {
      small: 'p-1 md:text-2xs/[120%] text-[8px]/[120%] font-bold',
      base: 'px-2 py-1 md:text-xs/[120%] text-2xs/[120%] font-bold',
      large: 'px-3 py-1 md:text-sm/[120%] text-xs/[120%] font-bold'
    },
    round: {
      base: 'rounded',
      full: 'rounded-full'
    },
    component: props.fillWidth ? 'w-full text-center' : 'w-fit text-center'
  }
})
</script>
